import { Box, VStack } from "@chakra-ui/react";
import { Field, FormInput, FormSelect, FormSwitch, FormTextarea } from "@/components/jobOffer/ui";
import { SectionCard, SectionHeader, Grid2 } from "@/components/jobOffer/ui/layout";
import { AddButton, ItemHeader } from "@/components/jobOffer/ui/listHelpers";
import { CHANNEL_OPTIONS, CHANNEL_SEQUENCE_MODE_OPTIONS } from "@/components/campaign/channelOptions";
import { LEAD_STATUS_OPTIONS } from "@/components/campaign/leadStatusOptions";

const AGENT_ACTION_OPTIONS = [
    { value: "Rozpocznij pierwszy kontakt sprzedażowy", label: "Rozpocznij pierwszy kontakt sprzedażowy" },
    { value: "Wyślij przypomnienie", label: "Wyślij przypomnienie" },
    { value: "Kontynuuj rozmowę / follow-up", label: "Kontynuuj rozmowę / follow-up" },
    { value: "Przekaż do człowieka", label: "Przekaż do człowieka" },
    { value: "Zakończ / archiwizuj", label: "Zakończ / archiwizuj" },
];

const newRule = () => ({
    id: crypto.randomUUID(), status: "New", isActive: false, agentAction: "",
    primaryChannel: null, fallbackChannel: null,
    channelSequenceMode: "Sequential", delayMinutes: null, parallelCommunication: false,
    startMessageTemplate: "",
});

const StepStatusAutomation = ({ values, onChange }) => {
    const set = (key, val) => onChange({ ...values, [key]: val });

    const rules = values.statusAutomationRules ?? [];
    const setRules = (next) => set("statusAutomationRules", next);
    const updateRule = (i, patch) => setRules(rules.map((r, idx) => idx === i ? { ...r, ...patch } : r));
    const removeRule = (i) => setRules(rules.filter((_, idx) => idx !== i));
    const addRule = () => setRules([...rules, newRule()]);

    return (
        <VStack w="full" align="stretch" gap={4}>
            <SectionCard>
                <SectionHeader number={10} title="Automatyzacja statusów" subtitle="Dla każdego naszego statusu leada: jaką akcję ma podjąć Agent i którym kanałem" />
                <VStack align="stretch" gap={4}>
                    {rules.map((r, i) => (
                        <Box key={r.id ?? i} borderWidth={1} borderColor="border.primary" borderRadius={8} p={4}>
                            <ItemHeader title={LEAD_STATUS_OPTIONS.find(o => o.value === r.status)?.label ?? "Nowa reguła statusu"} index={i} onRemove={() => removeRule(i)} />
                            <VStack align="stretch" gap={3}>
                                <Field label="Status" required>
                                    <FormSelect
                                        value={r.status ?? ""}
                                        onChange={(v) => updateRule(i, { status: v || null })}
                                        options={LEAD_STATUS_OPTIONS}
                                        placeholder="Wybierz status"
                                    />
                                </Field>
                                <FormSwitch label="Wyzwala akcję agenta" checked={!!r.isActive} onChange={(v) => updateRule(i, { isActive: v })} />
                                <Field label="Akcja agenta">
                                    <FormSelect
                                        value={r.agentAction ?? ""}
                                        onChange={(v) => updateRule(i, { agentAction: v || null })}
                                        options={AGENT_ACTION_OPTIONS}
                                        placeholder="Wybierz akcję"
                                    />
                                </Field>
                                <Grid2>
                                    <Field label="Kanał podstawowy">
                                        <FormSelect
                                            value={r.primaryChannel ?? ""}
                                            onChange={(v) => updateRule(i, { primaryChannel: v || null })}
                                            options={CHANNEL_OPTIONS}
                                            placeholder="Wybierz kanał"
                                        />
                                    </Field>
                                    <Field label="Kanał dodatkowy / fallback">
                                        <FormSelect
                                            value={r.fallbackChannel ?? ""}
                                            onChange={(v) => updateRule(i, { fallbackChannel: v || null })}
                                            options={CHANNEL_OPTIONS}
                                            placeholder="Brak"
                                        />
                                    </Field>
                                </Grid2>
                                <Grid2>
                                    <Field label="Kolejność wykorzystania kanałów">
                                        <FormSelect
                                            value={r.channelSequenceMode ?? ""}
                                            onChange={(v) => updateRule(i, { channelSequenceMode: v || null, parallelCommunication: v === "Parallel" })}
                                            options={CHANNEL_SEQUENCE_MODE_OPTIONS}
                                            placeholder="Wybierz"
                                        />
                                    </Field>
                                    {r.channelSequenceMode !== "Parallel" && (
                                        <Field label="Czas opóźnienia (minuty)">
                                            <FormInput
                                                type="number" min="0"
                                                value={r.delayMinutes ?? ""}
                                                onChange={(e) => updateRule(i, { delayMinutes: e.target.value === "" ? null : Number(e.target.value) })}
                                            />
                                        </Field>
                                    )}
                                </Grid2>
                                <Field label="Treść komunikatu startowego (opcjonalnie)" hint="Placeholdery: {imie}, {kampania}, {link}">
                                    <FormTextarea value={r.startMessageTemplate ?? ""} onChange={(e) => updateRule(i, { startMessageTemplate: e.target.value })} rows={3} />
                                </Field>
                            </VStack>
                        </Box>
                    ))}
                    <AddButton label="Dodaj regułę statusu" onClick={addRule} />
                </VStack>
            </SectionCard>
        </VStack>
    );
};

export default StepStatusAutomation;
